import { useMemo } from 'react';

import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { TEventType } from '@entities/eventJournal/model/types';
import { useFilterQuery, useGetFilterNames } from '@features/JournalEventsFilters/lib';
import { TFilterItem } from '@features/JournalEventsFilters/model/types';

interface IUseFilterByTypeProps {
    typesData: TEventType[];
}

export const useFilterByType = ({ typesData }: IUseFilterByTypeProps) => {
    const defaultValues = useGetFilterNames({
        filterData: typesData,
        queryKey: EventJournalQueries.type,
    });

    const { onFilterClickQuery, clearQueryValue } = useFilterQuery({
        queryKey: EventJournalQueries.type,
    });

    const data: TFilterItem[] = useMemo(() => {
        const list = typesData ?? [];
        const selected = new Set(defaultValues ?? []);

        return list.map<TFilterItem>((item) => ({
            label: item.name,
            value: String(item.id),
            isChecked: selected.has(String(item.name)),
            imgUrl: '',
        }));
    }, [typesData, defaultValues]);

    const onTypeClick = (value: string) => {
        onFilterClickQuery(value);
    };
    const onClearValuesCb = () => {
        void clearQueryValue();
    };

    return {
        data,
        defaultValues,
        onTypeClick,
        onClearValuesCb,
    };
};
